/**
 * 协议常量（docs/embedded-workbench-design.md §8）。
 *
 * 长度上限按**方向**分开，不要合并：父→子和子→父校验的是不同字段，
 * 上限值不同是有意为之，统一成一个数字会静默放宽其中一侧的校验面。
 */
/** 协议版本。与包的 semver 是两回事：包 major 变化不必动它，它一动必然是包 major。 */
export const EMBEDDED_PROTOCOL_VERSION = 2;
/**
 * 消息类型的**唯一来源**。
 *
 * 不要在任何地方再写这些字面量。构造消息时 TypeScript 还能靠联合类型挡住笔误，
 * 但两个 parser 的 `switch (data.type)` 判别的是 `unknown`——那里写错一个字符
 * 不会有任何编译错误，只会让这条消息**静默地不被识别**。
 *
 * 类型定义与这两张表的对齐由 `messages.ts` 底部的编译期断言保证。
 */
export const PARENT_MESSAGE = {
    connect: "tickbird:connect",
    tokenUpdate: "token:update",
    sessionEnd: "session:end",
    contextUpdate: "context:update",
    navigationUpdate: "navigation:update",
    appearanceUpdate: "appearance:update",
};
export const FRAME_MESSAGE = {
    hello: "tickbird:hello",
    connected: "tickbird:connected",
    ready: "tickbird:ready",
    tokenRequired: "token:required",
    sessionEnded: "session:ended",
    forbidden: "tickbird:forbidden",
    openStandalone: "navigation:open-standalone",
    navigationChanged: "navigation:changed",
    navigationBlock: "navigation:block",
    notificationReceived: "notification:received",
    notificationUnreadCountChanged: "notification:unread-count-changed",
    resize: "frame:resize",
    telemetry: "telemetry:event",
};
/** 全部消息类型，供穷尽性测试遍历。 */
export const PARENT_MESSAGE_TYPES = Object.values(PARENT_MESSAGE);
export const FRAME_MESSAGE_TYPES = Object.values(FRAME_MESSAGE);
/** 父→子（Tickbird iframe 侧校验宿主消息）。 */
export const PARENT_MAX_TEXT_LENGTH = 256;
export const PARENT_MAX_TOKEN_LENGTH = 8192;
/** 子→父（宿主侧校验 iframe 消息）。 */
export const FRAME_MAX_TEXT_LENGTH = 512;
/** 宿主通知回调中的纯文本与通知类型。 */
export const MAX_NOTIFICATION_TITLE_LENGTH = 256;
export const MAX_NOTIFICATION_BODY_LENGTH = 2000;
export const MAX_NOTIFICATION_TYPE_LENGTH = 64;
/** 路径字段的上限，两个方向一致。 */
export const MAX_PATH_LENGTH = 512;
/** `frameNonce` / `hostSessionId` 这类标识符。 */
export const MAX_IDENTIFIER_LENGTH = 128;
/** 宿主固定指定的工单项目编码（与服务端 Project.Code 上限一致）。 */
export const MAX_PROJECT_CODE_LENGTH = 64;
/** 枚举字面量与 `telemetry:event` 的 name。 */
export const MAX_ENUM_LENGTH = 32;
export const MAX_TELEMETRY_NAME_LENGTH = 64;
/** `EmbeddedBusinessContext` 各字段。 */
export const MAX_SYSTEM_CODE_LENGTH = 64;
export const MAX_ENTITY_TYPE_LENGTH = 64;
export const MAX_ENTITY_ID_LENGTH = 128;
/** 单个主题颜色值，包含函数名与空白。 */
export const MAX_THEME_COLOR_LENGTH = 128;
/** ISO 时间戳字符串。 */
export const MAX_TIMESTAMP_LENGTH = 64;
/** `frame:resize` 的像素上限，挡住宿主被诱导撑出超高 iframe。 */
export const MAX_FRAME_SIZE_PX = 100_000;
export const LOCALES = ["zh-Hans", "en"];
export const THEMES = ["light", "dark"];
export const SESSION_END_REASONS = ["logout", "expired", "revoked"];
export const FRAME_SESSION_END_REASONS = ["token-failure"];
export const TOKEN_REQUIRED_REASONS = ["missing", "expiring", "unauthorized"];
export const FORBIDDEN_REASONS = ["not-provisioned", "inactive", "no-roles"];
export const UNSAVED_WORK_REASONS = ["draft", "uploading"];
//# sourceMappingURL=constants.js.map